import { cn } from '@library/component-utils/cn';
import { useCallback } from 'react';

export interface RowProps {
  children: React.ReactNode;
  dataTestId: string;
  rowClassName?: string;
  onClickRow?: () => void;
}

export const Row = ({
  children,
  dataTestId,
  onClickRow = undefined,
  rowClassName = ''
}: RowProps) => {
  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent) => {
      if (['Enter', ' '].includes(e.key)) {
        if (onClickRow) {
          onClickRow();
        }
      }
    },
    [onClickRow]
  );

  return (
    <div
      className={cn(
        'hover:bg-soFresh-120 text-2xs border-soFresh-140 text-soClean-110 flex h-full min-h-16 w-full cursor-default items-center justify-between border-t px-4 text-left xl:text-xs',
        rowClassName
      )}
      data-testid={dataTestId}
      onClick={onClickRow}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
    >
      {children}
    </div>
  );
};
